import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import SchemaOrg from './SchemaOrg';

interface BreadcrumbItem {
  name: string;
  path: string;
}

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  
  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbs: BreadcrumbItem[] = [
      { name: 'Inicio', path: '/' }
    ];

    let currentPath = '';
    
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Map URL segments to readable names
      const nameMap: { [key: string]: string } = {
        'obra-nueva': 'Obra Nueva',
        'reformas': 'Reformas',
        'sobre-nosotros': 'Sobre Nosotros',
        'blog': 'Blog',
        'contacto': 'Contacto',
        'cookies': 'Política de Cookies',
        'privacidad': 'Política de Privacidad',
        'aviso-legal': 'Aviso Legal'
      };

      const name = nameMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
      breadcrumbs.push({ name, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();
  
  // Generate Schema.org breadcrumb data
  const breadcrumbSchemaData = {
    items: breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://constructoragranada.com${item.path}`
    }))
  };

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <>
      <SchemaOrg type="breadcrumb" data={breadcrumbSchemaData} />
      <div className="bg-white border-b border-gray-200">
        <div className="container-custom py-4">
          <ol className="flex items-center space-x-2 text-sm">
            {breadcrumbs.map((item, index) => (
              <li key={item.path} className="flex items-center">
                {index > 0 && (
                  <ChevronRight className="w-4 h-4 text-gray-400 mx-2" />
                )}
                {index === 0 ? (
                  <Link
                    to={item.path}
                    className="flex items-center text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    <Home className="w-4 h-4 mr-1" />
                    {item.name}
                  </Link>
                ) : index === breadcrumbs.length - 1 ? (
                  <span className="text-gray-900 font-medium">{item.name}</span>
                ) : (
                  <Link
                    to={item.path}
                    className="text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb; 